import { z } from 'zod';

const PasswordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters.')
  .regex(/[A-Za-z]/, 'Password must contain at least 1 letter.')
  .regex(/[0-9]/, 'Password must contain at least 1 number.');

export const SignUpFormSchema = z
  .object({
    confirmPassword: z.string().min(1, 'Please confirm your password.'),
    email: z.string().email('Please enter a valid email.'),
    name: z.string().min(1, 'Name is required.'),
    password: PasswordSchema,
    terms: z.literal<boolean>(true, {
      errorMap: () => ({ message: 'Please accept terms and conditions.' }),
    }),
  })
  .refine((v) => v.password === v.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  });

export type SignUpFormSchemaType = z.infer<typeof SignUpFormSchema>;
